// import {gql} from '@apollo/client'

export const mockTypeDefs = '' //gql``
